module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up reset-password"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', {
    attrs: {
      "user-signup": ""
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : (!_vm.loading && _vm.valid && !_vm.complete) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        _vm.completePasswordReset(_vm.newPassword, _vm.resetCodeUrl)
      }
    }
  }, [_c('h3', {
    staticClass: "form-heading"
  }, [_vm._v("Enter your new password")]), _vm._v(" "), _c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "name": "password",
      "autocomplete": "new-password",
      "label": "Your New Password",
      "type": "password",
      "required": "",
      "error-message": {
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&). '
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingReset
    }
  }, [_vm._v("Reset My Password")])], 1)], 1)], 1) : (!_vm.loading && _vm.valid && _vm.complete) ? _c('sk-panel', [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h4', {
    staticClass: "form-heading"
  }, [_vm._v("Yay! Your new password has successfully been updated.")]), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToSignIn()
      }
    }
  }, [_vm._v("Sign In")])], 1)])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9da59c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/user/password-validate.vue
// module id = 561
// module chunks = 0